
/**
 * `DivisionSwitcher` - The division switcher is a row of tabs changing the page content to the Mercedes-Benz retail business units.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import TabsBuilder from '@owc-packages/TabsBuilder/src/TabsBuilder.vue';
import { DivisionSwitcherComponent } from './DivisionSwitcher';
import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';

export default (ComponentInitializeDispatcher as DivisionSwitcherComponent).extend({
  name: 'owc-division-switcher',
  components: {
    TabsBuilder,
  },
  mixins: [OwcDataComponent],
  computed: {
    divisions: function() {
      return this.componentData?.divisions;
    },
    isDarkMode: function() {
      return Boolean(this.componentData?.darkMode);
    },
  },
});
